import { useBlogTagsQuery } from 'hooks/useBlogTagsQuery'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ComponentType } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'

export const BlogTagsMobile: ComponentType = () => {
    const router = useRouter()
    const { data } = useBlogTagsQuery()

    if (data) {
        const { tags } = data.blogTags

        return (
            <Container className="pb-20 scroller overflow-auto">
                <Row>
                    <Col>
                        <div className="d-flex flex-nowrap">
                            <Link href="/blog" passHref>
                                <Button tag="a" color="tab" active={!!!router.query.tagSlug}>
                                    Inicio
                                </Button>
                            </Link>
                            {tags.map((tag: any) => (
                                <Link
                                    key={tag.id}
                                    href={{
                                        pathname: '/blog/categoria/[tagSlug]',
                                        query: { tagSlug: tag.slug },
                                    }}
                                    as={`/blog/categoria/${tag.slug}`}
                                    passHref
                                >
                                    <Button tag="a" color="tab" title={tag.name} active={tag.slug === router.query.tagSlug}>
                                        {tag.name}
                                    </Button>
                                </Link>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    return null
}


